query SoccerTeamByTeamId (
  $teamId: UUID!
){
  team: soccerTeamByTeamId(teamId: $teamId) {
    squad
    teamId
  }
}
